/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import NextLink, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import { css, cx } from '@linaria/core';
import { Icon } from '@spaceshipapp/cambridge';
import withTracking from '../../hoc/withTracking';

interface RedirectionLinkProp {
  target?: '_self' | '_blank';
}
export type Props = LinkProps & React.HTMLAttributes<HTMLAnchorElement> & RedirectionLinkProp;

const Link: React.FC<Props> = (props) => {
  const {
    href,
    className,
    style,
    onClick,
    locale,
    children,
    target = '_blank',
    ...otherProps
  } = props;
  const { pathname = '' } = useRouter() || {};
  const active = !locale && pathname.includes(href as string);

  if (href && typeof href === 'string' && href.startsWith('http')) {
    return (
      <a
        style={style}
        className={className}
        href={href}
        target={target}
        rel="noopener noreferrer"
        onClick={onClick}
        {...otherProps}
      >
        {children} <Icon.ExternalLink className={externalStyle} />
      </a>
    );
  }

  return (
    <NextLink href={href} locale={locale} {...otherProps}>
      <a className={cx(className, active && 'active')} onClick={onClick} style={style}>
        {children}
      </a>
    </NextLink>
  );
};

const externalStyle = css`
  display: inline-block;
  margin-left: 0.25rem;
`;

export default withTracking('Link clicked')(Link);
